<template>
  <div class="sauth-wrapper">
      <div class="sauth-header">
        <img class="img" src="~@/assets/images/super/bg.png" alt="">
      </div>
      <div class="sauth-desc">
        <div class="desc">您正在进入</div>
        <div class="name">{{name}}</div>
        <div class="tip">因疫情防控需要获取您的信息</div>
      </div>
      <div class="btn-group">
        <button class="btn auth-btn" @click="handleAuth">提交登记手机号</button>
        <button class="btn other-btn" @click="handleOther">使用其他手机号登记</button>
      </div>
      <van-dialog v-model="show" title="请输入您的手机号" show-cancel-button confirm-button-text="提交"  :before-close="handleClose">
        <div class="other-input">
          <input v-model="otherMobile" class="input" type="tel" maxlength="11" placeholder="请输入您的手机号">
        </div>
      </van-dialog>
  </div>
</template>
<script>
import { Toast, Dialog } from 'vant'
import { submitAuth, getSiteInfo } from '@/api/super'
import { setStore, removeStore, checkPhone } from '@/utils/index'

export default {
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  data () {
    return {
      show: false,
      otherMobile: '',
      name: ''
    }
  },
  mounted () {
    this.detailId = this.$route.query.detailId
    const token = this.$route.query.token
    if (token) {
      setStore('token', token)
    }
    this.getSite(this.detailId)
  },
  destroyed () {
    removeStore('token')
  },
  methods: {
    getSite (id) {
      getSiteInfo(id).then((res) => {
        console.log(res)
        if (res.data.code === 200) {
          this.name = res.data.result.siteName
        }
      }).catch(() => {

      })
    },
    handleSubmit (done) {
      console.log(this.otherMobile)
      const requestData = {
        detailId: this.detailId,
        otherMobile: this.otherMobile
      }
      submitAuth(requestData).then((res) => {
        console.log(res)
        if (res.data.code === 200) {
          this.$router.push('/ssuc')
          done && done()
        } else {
          done && done(false)
        }
      }).catch(() => {

      })
    },
    handleAuth () {
      this.otherMobile = ''
      this.handleSubmit()
    },
    handleOther () {
      this.show = true
    },
    handleClose (action, done) {
      if (action === 'confirm') {
        console.log(this.otherMobile)
        if (!checkPhone(this.otherMobile)) {
          Toast({
            message: '手机号格式不正确'
          })
          done(false)
          return
        }
        this.handleSubmit(done)
      } else {
        done()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.sauth-wrapper {
  min-height: 100vh;
  background: #f7f7f7;
}
.sauth-header {
  .img {
    width: 100%;
  }
}
.sauth-desc {
  position: relative;
  margin: -20px 15px 15px 15px;
  padding: 15px 15px 8px 15px;
  border-radius: 10px;
  line-height: 2;
  background: #fff;
  z-index: 1;
  .desc {
    margin-top: 25px;
    text-align: center;
    font-size: 16px;
    color: #565656;
  }
  .name {
    margin-bottom: 25px;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #282828;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .tip {
    padding: 8px 0 0;
    border-top: 1px solid #f1f1f1;
    text-align: center;
    font-size: 12px;
    color: #565656;
  }
}
.btn-group {
  display: flex;
  flex-direction: column;
  .btn {
    box-sizing: border-box;
    margin: 15px 30px 10px;
    padding: 10px 0;
    border-radius: 30px;
    background-color: #427bff;
    font-size: 16px;

  }
  .auth-btn {
    color: #fff;
  }
  .other-btn {
    color: #565656;
    background-color: transparent;
  }
}
.other-input {
  background: #f8f8f8;
  margin: 15px;

  .input {
    box-sizing: border-box;
    background: #f8f8f8;
    padding: 10px;
    height: 100%;
    width: 100%;
  }
}
</style>
